import React from 'react';
import { BookOpenIcon, GiftIcon, LeafIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: LeafIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and professionals'
}];
export function SocialProof() {
  return <section className="bg-navy py-5" aria-label="What the teacher ready includes" data-id="element-216" data-mp="3f4w0k0myvke">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-white sm:justify-between" data-id="element-217" data-mp="3h7m141sgop4">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-218" data-mp="3utix082cse64">
            <Icon className="h-5 w-5 text-solar" aria-hidden="true" data-id="element-219" data-mp="3urg0r6alxosy" /> {label}
          </span>)}
      </div>
    </section>;
}